import * as React from 'react';
import { SVGProps } from 'react';

const IcRotate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M14.462 28a11.758 11.758 0 0 1-4.139-1.296A11.808 11.808 0 0 1 7 24.095a11.988 11.988 0 0 1-2.2-3.648C4.267 19.07 4 17.587 4 16c0-1.769.426-3.457 1.277-5.065.851-1.608 1.995-3.036 3.43-4.282H4.955V4.844H12v6.905h-1.846v-3.89a11.875 11.875 0 0 0-3.139 3.664c-.78 1.417-1.169 2.91-1.169 4.477 0 2.653.82 4.92 2.462 6.799 1.64 1.88 3.692 3 6.154 3.362V28ZM20 27.156V20.25h1.846v3.89a12.285 12.285 0 0 0 3.139-3.679A9.073 9.073 0 0 0 26.154 16c0-2.653-.82-4.92-2.462-6.799-1.64-1.88-3.692-3-6.154-3.362V4c2.995.362 5.488 1.658 7.477 3.89C27.005 10.12 28 12.823 28 16c0 1.769-.426 3.457-1.277 5.065-.851 1.608-1.995 3.036-3.43 4.282h3.753v1.809H20Z" />
      <path d="M20 12v8h-8v-8h8Zm-2 2h-4v4h4v-4Z" />
    </g>
  </svg>
);

export default IcRotate;
